import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgFundedNotTraded = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 22,
	height: 22,
	viewBox: "0 0 22 22",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M10.1124 3.00524H7.26815C5.77475 3.00524 5.02806 3.00524 4.45766 3.29587C3.95592 3.55152 3.54799 3.95944 3.29234 4.46118C3.00171 5.03158 3.00171 5.77828 3.00171 7.27167V14.7379C3.00171 16.2313 3.00171 16.978 3.29234 17.5484C3.54799 18.0502 3.95592 18.4581 4.45766 18.7137C5.02806 19.0044 5.77475 19.0044 7.26815 19.0044H14.7344C16.2278 19.0044 16.9745 19.0044 17.5449 18.7137C18.0466 18.4581 18.4546 18.0502 18.7102 17.5484C19.0009 16.978 19.0009 16.2313 19.0009 14.7379V11.8936M11.0013 7.44944H14.5566V11.0048M14.1122 3.44966V2.11639M17.6137 4.39241L18.5564 3.44966M18.5655 7.89386H19.8988M3.00171 12.2022C3.58118 12.2916 4.17486 12.3381 4.77939 12.3381C8.67817 12.3381 12.126 10.4071 14.2186 7.44944",
		stroke: "black",
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
});
export default SvgFundedNotTraded;
